<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content">
      <!--查询-->
      <div class="h-piece">
        <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="计算日期" style="width: 25%;">
              <el-date-picker
                  v-model="q.countDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="时间" style="width: 25%;" >
              <el-date-picker
                  style="width: 100%;"
                  v-model="q.cdate"
                  :clearable="true"
                  type="month"
                  value-format="yyyy-MM"
                  placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <!-- <el-form-item label="">
               <el-select v-model="q.sceneCode"
                          placeholder="请选择"
                          clearable>
                 <el-option label="已签收" value="Y"></el-option>
                 <el-option label="未签收" value="N"></el-option>
               </el-select>
             </el-form-item>-->

          </div>
        </el-form>
        <div class="l-screenBox">
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
          </div>
        </div>
      </div>

      <!--表格-->
      <div class="h-table h-mrt30">
        <span class="note">收入为不含税金额</span>
        <el-table
            :data="tableData"
            ref="multipleTable"
            :border="true"
            style="width: 100%"
            :row-key="(row) => row.userCode"
            max-height="450"
            :default-expand-all="false"
        >
          <el-table-column
              label="收入（万元）"
              prop="userName"
              width="140"
              show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="已下单未发货">
            <el-table-column
                label="审核中"
                prop="status20">
            </el-table-column>
            <el-table-column
                label="审核通过"
                prop="status4042"
            >
            </el-table-column>
            <el-table-column
                label="订单缺款"
                prop="status41"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column
              label="已发货未签收"
              prop="status50"
          >
          </el-table-column>
          <el-table-column
              label="已签收未开票（系统票）"
              prop="status60"
              width="180"
          >
          </el-table-column>
          <el-table-column label="已开票（系统票）">
            <el-table-column
                label="当月转化"
                prop="kaipiaoMonth"
            >
            </el-table-column>
            <el-table-column
                label="以前月度转化"
                prop="kaipiaoAll"
            >
            </el-table-column>
          </el-table-column>
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button type="primary" @click="exportExcel">批量导出</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ss from "../../api/SystemService";
import updownfile from '../../utils/updownfile'

export default {
  data() {
    return {
      q:{
        countDate: this.getNowTime(),
        cdate: '',
      },
      tableData:  [],
    }
  },
  methods:{
    //查询
    handleFilter(){
      ss.chanpin.selectOrderPriceYxPersonalList(this.q).then(rd => {
        console.log(rd);
        this.tableData = rd.msg;
      })
    },
    //重置
    resetData(){
      var countDate=this.getNowTime();
      this.q= {
        countDate: countDate,
        cdate:null
      }
    },
    //导出
    exportExcel(){
      updownfile.down("/api/swyl/v1/demo/bscOrderPriceYxPersonal/downloadExcel",this.q, "get", 'data');
    },
    //查询方法
    query(){
      this.handleFilter();
    },
    //处理默认选中当前日期
    getNowTime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      //var hour =" 00:00:00"; //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
      month = month + 1;
      month = month.toString().padStart(2, "0");
      date = date.toString().padStart(2, "0");
      var defaultDate = `${year}-${month}-${date}`;
      console.log(defaultDate)
      return defaultDate;
      this.$set(this.info, "stockDate", defaultDate);
    },

  },
  created() {
    this.query();
  },
}
</script>
<style lang="less" scoped>
.note{
  font-size: 12px;
  color: red;
  display: block;
  margin: 10px;
}
::v-deep .el-table__expand-icon{
  height: 11px!important;
  line-height: 11px!important;
}
</style>